import React from 'react';
import { Link } from 'react-scroll';
import './Footer.css';

const links = [
  { label: 'О нас', to: 'about' },
  { label: 'Услуги', to: 'services' },
  { label: 'Преимущества', to: 'whyus' },
  { label: 'Контакты', to: 'contacts' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <div className="footer__logo">
            <span>⚡</span> ЭНЕРГОГЛАЙД
          </div>
          <p className="footer__brand-desc">
            Комплексные услуги в сфере инжиниринга, проектирования
            и информационных технологий. г. Минск, Беларусь.
          </p>
        </div>

        <nav className="footer__nav">
          <div className="footer__nav-title">Навигация</div>
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              smooth
              duration={600}
              offset={-80}
              className="footer__nav-link"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="footer__contact">
          <div className="footer__nav-title">Контакты</div>
          <div className="footer__contact-item">📍 г. Минск, Беларусь</div>
          <div className="footer__contact-item">📞 +375 29 634 80 36</div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <span>© 2026 ООО «ЭНЕРГОГЛАЙД». Все права защищены.</span>
          <span className="footer__policy">Политика конфиденциальности</span>
        </div>
      </div>
    </footer>
  );
}
